<template>
    <div>
        <div class="content-header">
            <h3>查询</h3>
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                <el-form-item label="用户登录名">
                    <el-input v-model="formInline.userName" placeholder="用户登录名" clearable></el-input>
                </el-form-item>
                <el-form-item label="用户昵称">
                    <el-input v-model="formInline.userNick" placeholder="用户昵称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getList">查询</el-button>
                    <el-button type="success" @click="handleAdd">新增</el-button>
<!--                    <el-button type="warn" @click="handleSync">从ERP3.0同步用户</el-button>-->
                </el-form-item>
            </el-form>
        </div>
        <div class="content-wrap">
            <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize"  v-loading="loading">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="userId" label="用户标示"></el-table-column>
                <el-table-column prop="userName" label="登录名"></el-table-column>
                <el-table-column prop="userNick" label="昵称"></el-table-column>
                <el-table-column prop="platformGroupName" label="所属公司"></el-table-column>
                <el-table-column prop="platformNames" label="平台"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
                <el-table-column :formatter="convertStatus" label="状态"></el-table-column>
                <el-table-column label="操作" fixed="right" width="160">
                    <template slot-scope="scope">
                        <el-button type="warning " size="mini" @click="handleUpdate(scope.row)">修改</el-button>
                        <el-button type="success " size="mini" @click="handleRole(scope.row)">角色</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="用户管理" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="150px">
                <el-form-item label="用户登录名" :required="true">
                    <el-input v-model="form.userName" placeholder="建议姓名全拼" clearable></el-input>
                </el-form-item>
                <el-form-item label="用户昵称" :required="true">
                    <el-input v-model="form.userNick" placeholder="用户昵称" clearable></el-input>
                </el-form-item>
                <el-form-item label="用户密码" :required="true">
                    <el-input type="password" v-model="form.password" placeholder="用户密码" clearable></el-input>
                </el-form-item>

                <el-form-item label="LEADER">
                    <template>
                        <el-select v-model="form.leader"
                                   filterable
                                   remote
                                   reserve-keyword
                                   :remote-method="querySearch0"
                                   placeholder="请输入LEADER姓名或邮箱">
                            <el-option
                                    v-for="user in userSelList"
                                    :key="user.USER_ID"
                                    :label="user.USER_NAME"
                                    :value="user.USER_ID">
                            </el-option>
                        </el-select>
                    </template>
                </el-form-item>

                <el-form-item label="所属钉钉部门">
                    <template>
                            <!-- 调用树形下拉框组件 -->
                            <SelectTree
                                    :props="props"
                                    :options="optionData"
                                    :value="valueId"
                                    :clearable="isClearable"
                                    :accordion="isAccordion"
                                    @getValue="getValue($event)"/>
                    </template>
                </el-form-item>

                <el-form-item label="财务口径所属部门" >
                    <el-select v-model="form.financialDeptId" clearable  placeholder="财务口径所属部门">
                        <el-option label="产品中心" value=1></el-option>
                        <el-option label="供应链中心" value=2></el-option>
                        <el-option label="环境建设中心-财务" value=3></el-option>
                        <el-option label="环境建设中心-京东" value=4></el-option>
                        <el-option label="环境建设中心-人力行政" value=5></el-option>
                        <el-option label="环境建设中心-战略" value=6></el-option>
                        <el-option label="环境建设中心-战略第三方" value=7></el-option>
                        <el-option label="门店-新业务" value=8></el-option>
                        <el-option label="用户推广中心-渠道" value=9></el-option>
                        <el-option label="用户运营中心-京东POP" value=10></el-option>
                        <el-option label="用户运营中心-天猫" value=11></el-option>
                        <el-option label="用户运营中心-微信" value=12></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="是否财务口径管理员">
                    <el-switch
                            v-model="form.isFinancialAdmin"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="是"
                            inactive-text="否"
                            active-value="1"
                            inactive-value="0">
                    </el-switch>
                </el-form-item>

                <el-form-item label="状态">
                    <el-select :popper-append-to-body="true" v-model="form.status">
                        <el-option
                                v-for="item in statusList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属公司">
                    <el-select :popper-append-to-body="true" v-model="form.platformGroupId">
                        <el-option
                                v-for="item in platFormGroupList"
                                :key="item.platformGroupId"
                                :label="item.platformGroupName"
                                :value="item.platformGroupId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属平台">
                    <el-select   v-model="form.platformIds" multiple>
                        <el-option
                                v-for="item in platFormList"
                                :key="item.platformId"
                                :label="item.platformName"
                                :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="企微userId">
                    <el-input v-model="form.qyWeixinUserid" placeholder="企微userId"></el-input>
                </el-form-item>
                <el-form-item label="所属平台">
                    <el-input v-model="form.platformNames" placeholder="所属平台"  disabled></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateOrAdd">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog  title="用户角色管理" :visible.sync="dialogFormVisible1" center :fullscreen="true">
            <el-form :inline="true" :model="formInline1" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                <el-form-item>
                    <el-button type="primary" @click="getUserRoleList">查询</el-button>
                    <el-button type="success" @click="handleAddUserRole">新增</el-button>
                    <el-button type="warning" @click="dialogFormVisible1 = false">关闭</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="dataList1" stripe border center :size="GCONFIG.styleTableSize"  v-loading="loading1">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="userNick" label="用户名称"></el-table-column>
                <el-table-column prop="roleName" label="角色名称"></el-table-column>
                <el-table-column label="操作" fixed="right" width="160">
                    <template slot-scope="scope">
                        <el-button type="warning " size="mini" @click="handleDeleteRole(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="formInline1.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline1.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline1.recordsTotal">
                </el-pagination>
            </div>


            <el-dialog title="角色添加" :visible.sync="dialogFormVisible2" center  append-to-body>
                <el-form :inline="true" :model="formInline2" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                    <el-form-item>
                        <el-button type="primary" @click="getRoleList">查询</el-button>
                        <el-button type="success" @click="handleAddUserRolesave">保存</el-button>
                        <el-button type="warning" @click="dialogFormVisible2 = false">关闭</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="dataList2" stripe border center :size="GCONFIG.styleTableSize"  v-loading="loading2" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column prop="roleId" label="角色标示"></el-table-column>
                    <el-table-column prop="roleName" label="角色名"></el-table-column>
                    <el-table-column prop="status" :formatter="convertStatus" label="状态"></el-table-column>
                    <el-table-column prop="platformGroupName" label="所属公司"></el-table-column>
                </el-table>
                <div class="pagination-wrap">
                    <el-pagination
                            background
                            @size-change="handleSizeChange2"
                            @current-change="handleCurrentChange2"
                            :current-page="formInline2.currentPage"
                            :page-sizes="GCONFIG.pageSizes"
                            :page-size="formInline2.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="formInline2.recordsTotal">
                    </el-pagination>
                </div>
            </el-dialog>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        getMallUserList,
        saveOrUpdateMallUser,
        platFormList,
        getAllUsers,
        allMyPlatFormGroupList,
        getMallUserRoleList,
        saveUserRole,
        deleteUserRole,
        getMallRoleList,
        getMainDataUsers,
        getDeparts
    } from '../../api/api';
    import {getmd5} from '../../global/globalMethod';
    import SelectTree from "./treeSelect.vue";

    //定义组件
    export default {
        components: {
            SelectTree
        },
        data() {
            return {
                dataList: [],
                dataList1: [],
                dataList2: [],
                platFormGroupList:[],
                platFormList:[],
                userList:[],
                userSelList:[],
                statusList: [{value: 1, name: '有效'}, {value: -1, name: '无效'}],
                loading: true,
                loading1: true,
                loading2: true,
                dialogFormVisible: false,
                dialogFormVisible1: false,
                dialogFormVisible2: false,
                formInline: {
                    userName: "",
                    userNick: "",
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                formInline1: {
                    userId: "",
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                formInline2: {
                    roleName: "",
                    userId: "",
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                form: {
                    userName: '',
                    userNick: '',
                    password: '',
                    leader: '',
                    deptId: '',
                    financialDeptId: null,
                    isFinancialAdmin: "0",
                    platformGroupId: '',
                    platformIds: [],
                    platformId:'',
                    userId:'',
                    status:1,
                    qyWeixinUserid:''
                },
                form2: {
                    userId: '',
                    roleIds: [],
                },
                // 树形下拉框
                isClearable:true,      // 可清空（可选）
                isAccordion:true,      // 可收起（可选）
                valueId:"",            // 初始ID（可选）
                props:{                // 配置项（必选）
                    value: 'id',
                    label: 'name',
                    children: 'children'
                },
                // 选项列表（必选）
                list:[
                    {id:1,parentId:0,name:"一级菜单A",rank:1},
                    {id:2,parentId:0,name:"一级菜单B",rank:1},
                    {id:3,parentId:0,name:"一级菜单C",rank:1},
                    {id:4,parentId:1,name:"二级菜单A-A",rank:2},
                    {id:5,parentId:1,name:"二级菜单A-B",rank:2},
                    {id:6,parentId:2,name:"二级菜单B-A",rank:2},
                    {id:7,parentId:4,name:"三级菜单A-A-A",rank:3},
                    {id:8,parentId:7,name:"四级菜单A-A-A-A",rank:4},
                    {id:9,parentId:8,name:"五级菜单A-A-A-A-A",rank:5},
                    {id:10,parentId:9,name:"六级菜单A-A-A-A-A-A",rank:6},
                    {id:11,parentId:10,name:"七级菜单A-A-A-A-A-A-A",rank:7},
                    {id:12,parentId:11,name:"八级菜单A-A-A-A-A-A-A-A",rank:8},
                    {id:13,parentId:12,name:"九级菜单A-A-A-A-A-A-A-A-A",rank:9},
                    {id:14,parentId:13,name:"十级菜单A-A-A-A-A-A-A-A-A-A",rank:10},
                    {id:15,parentId:0,name:"一级菜单C",rank:1},
                    {id:16,parentId:0,name:"一级菜单C",rank:1},
                    {id:17,parentId:0,name:"一级菜单C",rank:1},
                    {id:18,parentId:0,name:"一级菜单C",rank:1},
                    {id:19,parentId:0,name:"一级菜单C",rank:1},
                    {id:20,parentId:0,name:"一级菜单C",rank:1},
                    {id:21,parentId:0,name:"一级菜单C",rank:1},
                    {id:22,parentId:0,name:"一级菜单C",rank:1},
                    {id:23,parentId:0,name:"一级菜单C",rank:1},
                    {id:24,parentId:0,name:"一级菜单C",rank:1},
                    {id:25,parentId:0,name:"一级菜单C",rank:1},
                    {id:26,parentId:0,name:"一级菜单C",rank:1},
                    {id:27,parentId:0,name:"一级菜单C",rank:1},
                    {id:28,parentId:0,name:"一级菜单C",rank:1},
                    {id:29,parentId:0,name:"一级菜单C",rank:1},
                    {id:30,parentId:0,name:"一级菜单C",rank:1},
                    {id:31,parentId:0,name:"一级菜单C",rank:1},
                    {id:32,parentId:0,name:"一级菜单C",rank:1},
                    {id:33,parentId:0,name:"一级菜单C",rank:1},
                    {id:34,parentId:0,name:"一级菜单C",rank:1},
                    {id:35,parentId:0,name:"一级菜单C",rank:1},
                    {id:36,parentId:0,name:"一级菜单C",rank:1},
                    {id:37,parentId:0,name:"一级菜单C",rank:1},
                    {id:38,parentId:0,name:"一级菜单C",rank:1},
                    {id:39,parentId:0,name:"一级菜单C",rank:1},
                    {id:40,parentId:0,name:"一级菜单end",rank:1}
                ]
            }
        },
        computed:{
            /* 转树形数据 */
            optionData(){
                let cloneData = JSON.parse(JSON.stringify(this.list))      // 对源数据深度克隆
                return  cloneData.filter(father=>{                      // 循环所有项，并添加children属性
                    let branchArr = cloneData.filter(child=>father.id == child.parentId);       // 返回每一项的子级数组
                    branchArr.length>0 ? father.children=branchArr : ''   //给父级添加一个children属性，并赋值
                    return father.parentId==0;      //返回第一层
                });
            }
        },
        //挂载时候执行
        mounted() {
            this.getDeparts();
            this.getList();
            allMyPlatFormGroupList().then((res) => {
                this.platFormGroupList = res.data;
            })
            platFormList().then((res) => {
                this.platFormList = res.data;
            })
            getAllUsers().then((res) => {
                if(res.data.status == '200'){
                    this.userList = res.data.value;
                    this.userSelList = res.data.value;
                }
            })
        },
        methods: {
            getDeparts(){
                getDeparts().then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.list = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            //定义查询方法
            getList() {
                this.loading = true;
                getMallUserList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline.recordsTotal = res.data.value.total;
                        this.dataList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAdd() {
                this.$message({
                    showClose: true,
                    message: '请从钉钉或AMS上创建用户',
                    type: 'error'
                });
                return;
                this.form= {
                    userName: '',
                    userNick: '',
                    password: '',
                    leader: '',
                    deptId: '',
                    financialDeptId: null,
                    isFinancialAdmin: "0",
                    platformGroupId: '',
                    platformIds: [],
                    platformId:'',
                    userId:'',
                    status:1,
                    qyWeixinUserid:''
                }
                this.dialogFormVisible = true;
            },
            handleSync() {
                getMainDataUsers(this.formInline).then((res) => {
                    this.loading1 = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '同步成功',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleUpdate(row) {
                this.form= {
                    userName:row.userName,
                    userNick: row.userNick,
                    leader: row.leader,
                    deptId: row.deptId,
                    financialDeptId:  row.financialDeptId==null?null:""+row.financialDeptId,
                    isFinancialAdmin:  row.isFinancialAdmin==null?""+0:""+row.isFinancialAdmin,
                    password: '',
                    platformGroupId: row.platformGroupId,
                    platformIds: [],
                    platformId:row.platformId,
                    userId:row.userId,
                    platformNames:row.platformNames,
                    qyWeixinUserid:row.qyWeixinUserid,
                    status:row.status
                }
                this.valueId = row.deptId;
                this.dialogFormVisible = true;
            },
            updateOrAdd() {
                if(this.form.password!=''){
                    this.form.password=getmd5(this.form.password);
                }
                this.form.deptId = this.valueId;
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveOrUpdateMallUser(this.form).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            convertStatus(row, column, cellValue) {
                if (row.status == 1) {
                    return "有效";
                } else {
                    return "无效";
                }
            },
            handleRole(row){
                this.dialogFormVisible1=true;
                this.formInline1.userId=row.userId;
                this.formInline2.userId=row.userId;
                this.getUserRoleList();
            },
            getUserRoleList() {
                this.loading1 = true;
                getMallUserRoleList(this.formInline1).then((res) => {
                    this.loading1 = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline1.recordsTotal = res.data.value.total;
                        this.dataList1 = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange1(val) {
                this.formInline1.pageSize = val;
                this.getUserRoleList()
            },
            handleCurrentChange1(val) {
                this.formInline1.currentPage = val;
                this.getUserRoleList()
            },
            handleDeleteRole(row){
                this.$confirm('删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    deleteUserRole({id:row.id}).then((res) => {
                        loading.close();
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getUserRoleList();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
            handleAddUserRole() {
                this.dialogFormVisible2 = true;
                this.form2.userId=this.formInline1.userId;
                this.getRoleList();
            },

            getRoleList() {
                this.loading2 = true;
                getMallRoleList(this.formInline2).then((res) => {
                    this.loading2 = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline2.recordsTotal = res.data.value.total;
                        this.dataList2 = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange2(val) {
                this.formInline2.pageSize = val;
                this.getRoleList()
            },
            handleCurrentChange2(val) {
                this.formInline2.currentPage = val;
                this.getRoleList()
            },
            handleAddUserRolesave(){
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveUserRole(this.form2).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getUserRoleList();
                        this.dialogFormVisible2 = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSelectionChange(val) {
                this.form2.roleIds = val;
            },
            querySearch0(queryString) {
                this.userSelList =this.querySearchFun(queryString);
            },
            querySearchFun(queryString) {
                var restaurants = this.userList;
                return queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.USER_NAME.indexOf(queryString) >-1);
                }
            },
            // 取值
            getValue(value){
                this.valueId = value
                // console.log(this.valueId);
            }
        }
    }
</script>
<style scoped>
    .el-scrollbar .el-scrollbar__view .el-select-dropdown__item{
        height: auto;
        max-height: 274px;
        padding: 0;
        overflow: hidden;
        overflow-y: auto;
    }
    .el-select-dropdown__item.selected{
        font-weight: normal;
    }
    ul li >>>.el-tree .el-tree-node__content{
        height:auto;
        padding: 0 20px;
    }
    .el-tree-node__label{
        font-weight: normal;
    }
    .el-tree >>>.is-current .el-tree-node__label{
        color: #409EFF;
        font-weight: 700;
    }
    .el-tree >>>.is-current .el-tree-node__children .el-tree-node__label{
        color:#606266;
        font-weight: normal;
    }
</style>


// WEBPACK FOOTER //
// src/views/sys/user.vue